// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reverse-route-link {\n    color:inherit;\n    font-size:1.16rem;\n}\n\n.reverse-route-link .reverse-icon {\n    margin-inline-end: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
